import { z } from 'zod';
import { documentKind, templateSchema } from './document.js';
import { listQueryInput, paginated } from './list.js';
/**
 * `template.list` (F1 "Start faster" gallery, `/templates`). `templates` is a
 * small global curated catalog with NO `ownerId` (`packages/db/src/schema/
 * documents.ts`) — unlike `persona.list` there is no `mine`/`public` scope to
 * enforce, just the active seeded catalog, optionally narrowed by `kind`
 * (F1's "Card: name, kind, description, 'Use template'." spec).
 */
export const templateSortColumns = ['createdAt', 'name'];
export const templateListQuery = listQueryInput(templateSortColumns, { defaultSort: 'name' }).extend({
    kind: documentKind.optional(),
});
export const templateListResult = paginated(templateSchema);
